import type { LocalizedHierarchyFragment$data } from '$houdini';
import type { Locale } from '$lib/i18n/types';

export function getAddressFromHierarchy(hierarchy: { label?: string | null; value: string }[]) {
	return {
		country: hierarchy[0]?.label ?? undefined,
		region: hierarchy[1]?.label ?? undefined,
		department: hierarchy[2]?.label ?? undefined,
		city: hierarchy[3]?.label ?? undefined,
	};
}

export function getAddressFromLocalizedHierarchies(
	hierarchies: LocalizedHierarchyFragment$data[],
	locale: Locale,
) {
	const hierarchy
		= hierarchies.find(h => h.locale === locale) ?? hierarchies.find(h => h.locale === 'en-US');

	return getAddressFromHierarchy(hierarchy?.hierarchy ?? []);
}
